import { FormatControlId, RibbonControlId } from 'owa-ribbon-ids';

/**
 * regular scaling)
 */

/**
 * Add the controls here that should never display their labels
 */
export const controlsWithoutLabels: RibbonControlId[] = [
    FormatControlId.TableMergeCellsMenu,
    FormatControlId.TableSplitCellsMenu,
    FormatControlId.TableInsertMenu,
    FormatControlId.TableAlignCellVerticallyMenu,
    FormatControlId.TableAlignCellHorizontallyMenu,
    FormatControlId.InsertRowAbove,
    FormatControlId.InsertRowBelow,
    FormatControlId.InsertColumnLeft,
    FormatControlId.InsertColumnRight,
    FormatControlId.DeleteTable,
    FormatControlId.DeleteColumns,
    FormatControlId.DeleteRows,
    FormatControlId.MergeAbove,
    FormatControlId.MergeBelow,
    FormatControlId.MergeLeft,
    FormatControlId.MergeRight,
    FormatControlId.SplitCellsHorizontally,
    FormatControlId.SplitCellsVertically,
    FormatControlId.AlignTableCellCenter,
    FormatControlId.AlignTableCellLeft,
    FormatControlId.AlignTableCellRight,
    FormatControlId.AlignTableCellTop,
    FormatControlId.AlignTableCellMiddle,
    FormatControlId.AlignTableCellBottom,
];

/**
 * Add the controls here that should NOT have their labels dropped when scaling
 * Note, These controls are ones that start off with labels. For controls that never
 * have labels, please place in controlsWithoutLabels section
 */
export const controlsDontDropLabels: RibbonControlId[] = [];

/**
 * Add the controls here that should NOT move to the overflow when scaling
 */
export const controlsDontMoveToOverflow: RibbonControlId[] = [];
